import { render, staticRenderFns } from "./RewardModal.vue?vue&type=template&id=6b4a80b4&scoped=true"
import script from "./RewardModal.vue?vue&type=script&lang=js"
export * from "./RewardModal.vue?vue&type=script&lang=js"
import style0 from "./RewardModal.vue?vue&type=style&index=0&id=6b4a80b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4a80b4",
  null
  
)

export default component.exports